import { formatCurrency } from '../../../utils/formatNumbers';

export function getReplacementCards(recommendations) {
    return recommendations.map((recommendation) => ({
        id: recommendation.id,
        name: recommendation.card.name,
        hospital: recommendation.card.hospital?.name,
        savings: formatCurrency(recommendation.recommendation_value ?? 0, 0) + '/yr',
        savingsValue: recommendation.recommendation_value ?? 0,
        openQuantity: recommendation.custom_open ?? recommendation.open_quantity ?? 0,
        holdQuantity: recommendation.custom_hold ?? recommendation.hold_quantity ?? 0,
        procedures: recommendation.card.procedures ?? []
    }));
}

export function getSelectedRecommendationIds(replacement, recommendations) {
    if (replacement?.replacement_status === 'open' || replacement?.replacement_status === 'accepted') {
        return recommendations.map((recommendation) => recommendation.id);
    }

    if (replacement?.replacement_status === 'rejected') {
        return [];
    }

    return recommendations
        .filter((recommendation) => recommendation.status === 'accepted')
        .map((recommendation) => recommendation.id);
}

export function getTotalSavings(recommendations, selectedIds) {
    return recommendations
        .filter((recommendation) => selectedIds.includes(recommendation.id))
        .reduce((total, recommendation) => total + (recommendation.recommendation_value ?? 0), 0);
}
